// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQjqh","label":"styles_label__23oJA"};